import { render } from "./chatPrivadoView.vue?vue&type=template&id=8245a3d0&scoped=true"
import script from "./chatPrivadoView.vue?vue&type=script&lang=js"
export * from "./chatPrivadoView.vue?vue&type=script&lang=js"

import "./chatPrivadoView.vue?vue&type=style&index=0&id=8245a3d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8245a3d0"]])

export default __exports__